<template>
    <div>
        <ApplicationOverlay />
        <ResultsTopPanel />
        <ResultsAlertContainer />
        <ResultsOnlineClinics />
        <ResultsAlertNoResultsFound />
        <ResultsSearchResults />
        <ResultsPrintDirectory />
    </div>
</template>
